import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pcs-accordion-panel-header',
  templateUrl: './accordion-panel-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionPanelHeaderComponent {

}
